// src/pages/PasswordProtection.js
import React, { useState } from "react";

export default function PasswordProtection({ checkPassword, passwordError, variant = "card" }) {
  const [passwordInput, setPasswordInput] = useState("");
  const isEmbedded = variant === "embedded";

  const handleFormSubmit = (e) => {
    e.preventDefault();
    checkPassword(passwordInput);
  };

  return (
    <div
      className={
        isEmbedded
          ? "w-full rounded-2xl border border-slate-200 bg-white p-4 text-left sm:p-5"
          : "w-full max-w-md rounded-xl border border-slate-200 bg-white/95 p-6 text-left shadow-[0_30px_90px_-60px_rgba(2,6,23,0.8)] backdrop-blur sm:p-8"
      }
    >
      <form onSubmit={handleFormSubmit} className={isEmbedded ? "space-y-4" : "space-y-5"}>
        <div>
          <h2 className={isEmbedded ? "text-xl font-semibold tracking-tight text-slate-950" : "text-2xl font-semibold tracking-tight text-slate-950"}>
            Password required
          </h2>
        </div>

        <div className="field-group">
          <label htmlFor="page-password" className="sr-only">
            Password
          </label>
          <input
            id="page-password"
            type="password"
            value={passwordInput}
            onChange={(e) => setPasswordInput(e.target.value)}
            required
            className="field-input"
            placeholder="Password"
          />
          {passwordError && (
            <p className="text-sm font-medium text-rose-600">{passwordError}</p>
          )}
        </div>

        <button type="submit" className="primary-button w-full">
          View page
        </button>
      </form>
    </div>
  );
}
